import React from "react";
import { Typography, Paper, Box, Link } from "@mui/material";

function Shipping() {
  return (
    <Box
      sx={{
        backgroundColor: "#f4f9ff",
        minHeight: "100vh",
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      {/* Header */}
      <div className="header">
        <img src="/logo.png" alt="Smart Parking Logo" className="logo" />
        <div className="heading-text">
          <br />
          <Typography variant="h4" className="title">
            Smart Parking App
          </Typography>
          <Typography variant="body2" className="caption">
            "Empowering Digital India .."
          </Typography>
        </div>
      </div>

     
      {/* Main Content */}
      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: 4,
          backgroundColor: "#ffffff",
          maxWidth: 380,
          width: "87%",
          mx: "auto",
        }}
      >
        <Typography
          variant="h5"
          sx={{ mb: 2, fontWeight: "medium", color: "#1565c0" }}
        >
          Shipping Policy
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          At Smart Parking App, we provide a digital service for booking parking slots and do not offer physical products or shipping services. Please review our Shipping Policy for clarity regarding our service-based operations.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          1. Nature of Service
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          The Smart Parking App is a service-based platform that enables users to book parking slots conveniently through our mobile application. As such, no physical goods are sold or shipped to customers.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          2. Service Delivery
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          Upon successful booking of a parking slot, users will receive a digital confirmation via the Smart Parking App, including details such as the parking location, date, and time. This confirmation serves as proof of your booking and is delivered instantly through the app or via email.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          3. No Physical Shipping
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          Since our services are entirely digital and related to parking facilities, there is no physical shipping involved. All transactions and confirmations are handled electronically through the app or associated communication channels.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          4. Technical Support
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          In case of any issues with accessing your booking confirmation or using the app, our support team is available to assist you promptly. Please reach out to us via the contact details provided below.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          5. Changes to Policy
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          We reserve the right to update or modify this Shipping Policy at any time. Any changes will be posted on this page, and continued use of the app constitutes acceptance of the updated policy.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          6. Contact Us
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          For any questions or concerns regarding this Shipping Policy or our services, please contact us at:
          <br />
          Email: <Link href="mailto:parkingsupport@apptech.co.in" sx={{ color: "#1565c0" }}>parkingsupport@apptech.co.in</Link>
          <br />
          Phone: <Link href="tel:+917001841402" sx={{ color: "#1565c0" }}>+91 7001841402</Link>
        </Typography>
      </Paper>
    </Box>
  );
}

export default Shipping;